import React from "react";
import { Phone, Mail, MapPin, Clock, ShieldCheck, Award, Headphones, MessageCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { useT } from "../i18n";
import { useSettings } from "../lib/useSettings";

export function About() {
  const { t, lang } = useT();
  const s = useSettings();
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">{t("nav.about")}</h1>
      <p className="text-muted-foreground leading-relaxed mb-10">
        {lang === "ro"
          ? `${s.company_name || "ClickRent"} este partenerul tău de încredere pentru închirieri auto. Cu o flotă modernă și confirmare rapidă pe WhatsApp, îți oferim cea mai simplă experiență de mobilitate.`
          : `${s.company_name || "ClickRent"} is your trusted partner for car rentals. With a modern fleet and fast WhatsApp confirmation, we offer the simplest mobility experience.`}
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {[{ icon: ShieldCheck, tx: lang === "ro" ? "Siguranță" : "Safety" }, { icon: Award, tx: lang === "ro" ? "Calitate" : "Quality" }, { icon: Headphones, tx: lang === "ro" ? "Suport 24/7" : "24/7 Support" }].map((x, i) => (
          <div key={i} className="border border-border rounded-lg p-6"><x.icon className="h-6 w-6 text-accent mb-3" /><p className="font-heading font-semibold">{x.tx}</p></div>
        ))}
      </div>
    </div>
  );
}

export function Contact() {
  const { t, lang } = useT();
  const s = useSettings();
  const wa = s.whatsapp ? `https://wa.me/${s.whatsapp}` : "#";
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-8">{t("nav.contact")}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <div className="space-y-5">
          {s.phone && <div className="flex items-center gap-3"><div className="bg-black text-white p-2.5 rounded-md"><Phone className="h-4 w-4" /></div><a href={`tel:${s.phone}`} className="text-sm">{s.phone}</a></div>}
          {s.email && <div className="flex items-center gap-3"><div className="bg-black text-white p-2.5 rounded-md"><Mail className="h-4 w-4" /></div><a href={`mailto:${s.email}`} className="text-sm">{s.email}</a></div>}
          {s.address && <div className="flex items-center gap-3"><div className="bg-black text-white p-2.5 rounded-md"><MapPin className="h-4 w-4" /></div><span className="text-sm">{s.address}</span></div>}
          {s.program && <div className="flex items-center gap-3"><div className="bg-black text-white p-2.5 rounded-md"><Clock className="h-4 w-4" /></div><span className="text-sm">{s.program}</span></div>}
          <a href={wa} target="_blank" rel="noreferrer" data-testid="contact-whatsapp">
            <Button className="rounded-md bg-[#25D366] hover:bg-[#20bd5a] gap-2 mt-2"><MessageCircle className="h-4 w-4" /> {t("nav.whatsapp")}</Button>
          </a>
        </div>
        <div className="border border-border rounded-lg overflow-hidden h-64 bg-secondary">
          <iframe title="map" className="w-full h-full border-0" src="https://www.openstreetmap.org/export/embed.html?bbox=21.1%2C45.7%2C21.3%2C45.8&layer=mapnik" />
        </div>
      </div>
    </div>
  );
}

export function Terms() {
  const { t } = useT();
  const s = useSettings();
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-bold tracking-tight mb-6">{t("terms.title")}</h1>
      <p className="text-muted-foreground leading-relaxed mb-8">{t("terms.body")}</p>
      <div className="border border-border rounded-lg p-6 text-sm space-y-1.5">
        <p className="font-semibold mb-2">{t("footer.company_info")}</p>
        <p>{s.company_name}</p>
        {s.cui && <p>CUI: {s.cui}</p>}
        {s.reg_com && <p>Reg. Comerțului: {s.reg_com}</p>}
        {s.sediu_social && <p>{s.sediu_social}</p>}
      </div>
      <div className="flex gap-4 mt-6 text-sm">
        <a href="https://anpc.ro/" target="_blank" rel="noreferrer" className="text-accent font-semibold">ANPC</a>
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-accent font-semibold">SOL</a>
      </div>
    </div>
  );
}
